// Modelos de Notas internas de cotización — /api/quotes/{quoteId}/notes (V91).
//
// businessId/userId salen del JWT (NO se envían como query/body).
// `mentions` y `attachments` se transportan como STRINGS JSON crudos (así los
// guarda y devuelve el backend): mentions = "[2,5]" (ids de usuarios),
// attachments = JSON de objetos con storageRef/fileName/mimeType/sizeBytes/url.

/** Adjunto de una nota (objeto dentro del string JSON `attachments`). */
export interface QuoteNoteAttachment {
  storageRef: string;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
  url: string;
}

/** Usuario mencionado, resuelto por el backend (id + nombre legible). */
export interface QuoteNoteMentionedUser {
  id: number;
  name: string;
}

/** Respuesta de una nota — GET /api/quotes/{quoteId}/notes (orden cronológico asc). */
export interface QuoteNoteResponse {
  id: number;
  quoteId: number;
  userId: number;
  authorName: string;
  authorEmail: string;
  content: string;
  /** String JSON crudo de ids, ej. "[2,5]" (nullable). */
  mentions: string | null;
  mentionedUsers: QuoteNoteMentionedUser[];
  /** String JSON crudo de adjuntos (nullable). */
  attachments: string | null;
  datetimeCreated: string;
  datetimeUpdated: string;
}

/** Body de creación/edición. content requerido al crear; parcial al editar. */
export interface QuoteNoteRequest {
  content?: string;
  /** String JSON de ids mencionados, ej. "[2,5]". */
  mentions?: string;
  /** String JSON de adjuntos. */
  attachments?: string;
}

/** Parsea el string JSON de adjuntos a un arreglo tipado (tolerante a null/JSON inválido). */
export function parseNoteAttachments(json?: string | null): QuoteNoteAttachment[] {
  if (!json) return [];
  try {
    const parsed = JSON.parse(json);
    return Array.isArray(parsed) ? (parsed as QuoteNoteAttachment[]) : [];
  } catch {
    return [];
  }
}

/** Parsea el string JSON de menciones a un arreglo de ids (tolerante a null/JSON inválido). */
export function parseNoteMentions(json?: string | null): number[] {
  if (!json) return [];
  try {
    const parsed = JSON.parse(json);
    return Array.isArray(parsed) ? parsed.filter((x): x is number => typeof x === 'number') : [];
  } catch {
    return [];
  }
}
